/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $Handbook = {
    properties: {
        id: {
    type: 'number',
},
        categoryId: {
    type: 'number',
},
        subCategoryId: {
    type: 'number',
},
        name: {
    type: 'string',
},
        file: {
    type: 'string',
},
        createdAt: {
    type: 'string',
},
    },
};